import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FileUploadService } from '../../services/file-upload.service';
import { RouteShareService } from '../../services/route-share.service';

export const documentResolver: ResolveFn<boolean> = async (route, _state) => {
  const fileUploadService: FileUploadService = inject(FileUploadService);

  const rss: RouteShareService = inject(RouteShareService);
  const id = route.parent?.params['id'] as string;

  // The project document picker is not needed for the first render, so load it without blocking the route.
  rss.selectableDocuments = [];
  void fileUploadService.getSelectableDocuments(id).then(
    docs => { if (rss.botConfig._id === id) rss.selectableDocuments = docs; },
    () => { /* picker stays empty; it is reloaded after the next document change */ }
  );

  const [, files] = await Promise.all([fileUploadService.loadAllowedTypes(), fileUploadService.getFiles(id)]);
  rss.documents = files.docs;

  const docId = route.firstChild?.params['docid'] as string;
  if (docId) {
    rss.document = rss.documents.find(doc => doc._id === docId);
    rss.documentChunks = await fileUploadService.getFileChunks(id, rss.document?.docSearchId ?? '');
  } else {
    rss.document = undefined;
    rss.documentChunks = undefined;
  }

  return true;
};
